import axios from "../../../helper/axios";
import * as actionTypes from "../actionTypes";
import setAuthToken from "../../../utils/setAuthToken";

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (token, userId, userName, role) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    token,
    userId,
    userName,
    role,
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error,
  };
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expDate");
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

export const checkAuthTimeout = (expS) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(logout());
    }, expS * 1000);
  };
};

export const login = (authData, callback) => async (dispatch, getState) => {
  dispatch(authStart());
  // console.log(authData);
  try {
    const response = await axios.post("users/login", authData);

    const data = parseJwt(response.data.token);
    const expDate = new Date(new Date(data.exp * 1000));
    console.log(data);
    // console.log(expDate);
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("expDate", expDate);
    setAuthToken(response.data.token);
    dispatch(authSuccess(response.data.token, data.id, data.name, data.role));
    callback();
  } catch (error) {
    console.log(error);
    // dispatch(authFail(error.response.data.message));
    dispatch(authFail("Something went wrong"));
  }
};

// for clear errors
export const authClearError = () => {
  return {
    type: actionTypes.AUTH_ERROR,
  };
};

// check token in local storge in every reload
export const authCheckState = () => {
  return (dispatch) => {
    // console.log('auth file: authCheckState ');
    const token = localStorage.getItem("token");
    if (!token) {
      dispatch(logout());
    } else {
      // i put new Date cuz local storage retuen string
      const expDate = new Date(localStorage.getItem("expDate"));
      if (expDate <= new Date()) {
        dispatch(logout());
      } else {
        const data = parseJwt(token);
        if (localStorage.getItem("fullName")) {
          dispatch(
            authSuccess(
              token,
              data.id,
              localStorage.getItem("fullName"),
              data.role
            )
          );
        } else {
          dispatch(authSuccess(token, data.id, data.name, data.role));
        }
        dispatch(
          checkAuthTimeout((expDate.getTime() - new Date().getTime()) / 1000)
        );
      }
    }
  };
};
